// extracted by mini-css-extract-plugin
export default {"footer":"hotel-extra-info_footer__dMrV8"};